import { render, staticRenderFns } from "./ticketModal.vue?vue&type=template&id=32f09110&scoped=true"
import script from "./ticketModal.vue?vue&type=script&lang=js"
export * from "./ticketModal.vue?vue&type=script&lang=js"
import style0 from "./ticketModal.vue?vue&type=style&index=0&id=32f09110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f09110",
  null
  
)

export default component.exports